import { Controller, useFormContext } from 'react-hook-form';
import { IndexPath } from '@ui-kitten/components';
import { format } from 'date-fns';

import { Select, SelectProps } from '../Select';
import { SelectItem } from '../SelectItem';

interface Props extends Omit<
	SelectProps,
	'value' | 'onSelect' | 'onBlur' | 'children' | 'error' | 'errors'
> {
	name: string;
	availableTimes: Date[];
}
export const FormTimeSelect = ({ name, availableTimes, ...selectProps }: Props) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
				<Select
					{...selectProps}
					onBlur={onBlur}
					error={!!error}
					errors={error?.message ? [error?.message] : undefined}
					value={value ? format(value, 'HH:mm') : undefined}
					onSelect={(selectedIndexPath) => {
						if (!(selectedIndexPath instanceof IndexPath)) return;
						const selectedTimeValue = selectedIndexPath.row;

						return onChange(availableTimes[selectedTimeValue]);
					}}
				>
					{availableTimes.map((time) => (
						<SelectItem key={time.toDateString()} title={format(time, 'HH:mm')} />
					))}
				</Select>
			)}
		/>
	);
};
